/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Dialog_Reject_Title_InInputs */

const vi_sl_detail_dialog_reject_title_in = /** @type {(inputs: Sl_Detail_Dialog_Reject_Title_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ chối phiếu nhập`)
};

/**

* @param {Sl_Detail_Dialog_Reject_Title_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_dialog_reject_title_in = /** @type {((inputs?: Sl_Detail_Dialog_Reject_Title_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Dialog_Reject_Title_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_dialog_reject_title_in(inputs)
});